// order depends on scenes-data.ts

export enum Scenes {
  FloorPlan = 0,
  Scene1 = 1,
  Scene2 = 2,
  Scene3 = 3,
  Scene4 = 4,
}
